/**
 * InviteModalHeader component
 * Header with title and close button
 */

import React from 'react';
import { View, Text, Pressable, Platform } from 'react-native';
import { WEB_HOVER_TRANSITION_STYLE } from '../../../src/shared/constants/animations';
import { useInviteModalStyles } from '../../../src/friends/contexts/InviteModalStylesContext';

interface InviteModalHeaderProps {
  onClose: () => void;
  testID?: string;
}

export const InviteModalHeader: React.FC<InviteModalHeaderProps> = ({ onClose, testID }) => {
  const styles = useInviteModalStyles();
  return (
    <View style={styles.header} testID={testID || 'invite-modal-header'}>
      <Text style={styles.headerTitle}>Invite Friends</Text>
      <Pressable
        onPress={onClose}
        style={({ pressed, hovered }) => [
          Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }),
          pressed && styles.closeButtonPressed,
          hovered && Platform.OS === 'web' && styles.closeButtonHover,
        ]}
        testID={testID ? `${testID}-close-button` : 'invite-modal-header-close-button'}
      >
        <Text style={styles.closeButton}>×</Text>
      </Pressable>
    </View>
  );
};

